// Search rows draw a hike's indexed thumbnail_url. A few hikes are indexed with
// none, and a URL can still fail to load; either way the row should show the
// hike placeholder rather than the browser's broken-image icon.

export function hikeThumbnailSrc(url: string | null | undefined, placeholder: string): string {
  return url && url.trim() ? url : placeholder;
}

// Called from the <img>'s error event. Swaps in the placeholder once — if the
// placeholder itself fails, it stops there instead of looping on error events.
export function showThumbnailPlaceholder(img: EventTarget | null, placeholder: string): void {
  if (!(img instanceof HTMLImageElement) || img.dataset.thumbnailPlaceholder === 'true') return;

  img.dataset.thumbnailPlaceholder = 'true';
  img.src = placeholder;
}
